var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect, useRef } from 'react';
import throttle from 'lodash/throttle';
import { useBoundary } from '~/hooks/useBoundary';
import { addWindowEventListener, removeWindowEventListener, } from '~/utils/windowEventListen';
function BoxElement(props) {
    var box = props.box, _a = props.width, width = _a === void 0 ? 150 : _a, _b = props.height, height = _b === void 0 ? 150 : _b, _c = props.padding, padding = _c === void 0 ? 30 : _c, _d = props.border, border = _d === void 0 ? 35 : _d, _e = props.margin, margin = _e === void 0 ? 40 : _e, onChangeBox = props.onChangeBox;
    var marginArea = {
        x: 0,
        y: 0,
        width: width + margin * 2 + border * 2 + padding * 2,
        height: height + margin * 2 + border * 2 + padding * 2,
    };
    var borderArea = {
        x: margin,
        y: margin,
        width: width + border * 2 + padding * 2,
        height: height + border * 2 + padding * 2,
    };
    var paddingArea = {
        x: margin + border,
        y: margin + border,
        width: width + padding * 2,
        height: height + padding * 2,
    };
    var contentArea = {
        x: margin + border + padding,
        y: margin + border + padding,
        width: width,
        height: height,
    };
    var elementRef = useRef(null);
    var boundary = useBoundary();
    var _f = __read(useState(function () {
        return {
            x: Math.random() * (window.innerWidth / 2),
            y: Math.random() * (window.innerHeight / 2),
        };
    }), 2), boxElementLocation = _f[0], setBoxElementLocation = _f[1];
    useEffect(function () {
        changeBox();
    }, []);
    var changeBox = function () {
        var element = elementRef.current;
        throttledOnChangeBox === null || throttledOnChangeBox === void 0 ? void 0 : throttledOnChangeBox(__assign(__assign({}, box), { boundingClientRect: element.getBoundingClientRect(), clientWidth: element.clientWidth, clientHeight: element.clientHeight, clientLeft: element.clientLeft, clientTop: element.clientTop, scrollWidth: element.scrollWidth, scrollHeight: element.scrollHeight, scrollLeft: element.scrollLeft, scrollTop: element.scrollTop, offsetWidth: element.offsetWidth, offsetHeight: element.offsetHeight }));
    };
    var throttledOnChangeBox = throttle(onChangeBox, 50);
    var changeLocation = function (_a) {
        var pageX = _a.pageX, pageY = _a.pageY, baseX = _a.baseX, baseY = _a.baseY;
        var boxAreaWidth = width + border * 2 + padding * 2 + margin * 2;
        var boxAreaHeight = height + border * 2 + padding * 2 + margin * 2;
        var x = baseX + pageX;
        if (x + boxAreaWidth > boundary.width) {
            x = boundary.width - boxAreaWidth;
        }
        else if (x < 0) {
            x = 0;
        }
        var y = baseY + pageY;
        if (y + boxAreaHeight > boundary.height) {
            y = boundary.height - boxAreaHeight;
        }
        else if (y < 0) {
            y = 0;
        }
        setBoxElementLocation({ x: x, y: y });
        changeBox();
    };
    var changeLocationByMouseMove = function (_a) {
        var startX = _a.startX, startY = _a.startY;
        var element = elementRef.current;
        var boundingClientRect = element.getBoundingClientRect();
        var baseX = boundingClientRect.x + window.pageXOffset - margin - startX;
        var baseY = boundingClientRect.y + window.pageYOffset - margin - startY;
        var handleWindowMouseMove = function (event) {
            event.preventDefault();
            var pageX = event.pageX, pageY = event.pageY;
            changeLocation({ pageX: pageX, pageY: pageY, baseX: baseX, baseY: baseY });
        };
        var handleWindowMouseUp = function () {
            removeWindowEventListener('mouseup', handleWindowMouseUp);
            removeWindowEventListener('mousemove', handleWindowMouseMove);
        };
        addWindowEventListener('mouseup', handleWindowMouseUp);
        addWindowEventListener('mousemove', handleWindowMouseMove);
    };
    var handleBoxElementScroll = function () {
        changeBox();
    };
    var handleBoxElementMouseDown = function (event) {
        var pageX = event.pageX, pageY = event.pageY;
        changeLocationByMouseMove({ startX: pageX, startY: pageY });
    };
    var handleBoxSVGMouseDown = function (event) {
        var pageX = event.pageX, pageY = event.pageY;
        changeLocationByMouseMove({ startX: pageX, startY: pageY });
    };
    return (React.createElement("div", { style: { position: 'relative' } },
        React.createElement("svg", { style: {
                position: 'absolute',
                transform: "translate(".concat(boxElementLocation.x, "px, ").concat(boxElementLocation.y, "px)"),
            }, width: marginArea.width, height: marginArea.height, onMouseDown: handleBoxSVGMouseDown },
            React.createElement("rect", { x: marginArea.x + 1, y: marginArea.y + 1, width: marginArea.width - 2, height: marginArea.height - 2, style: {
                    fill: 'transparent',
                    stroke: '#000000',
                    strokeWidth: '2',
                    strokeDasharray: '10 10',
                } }),
            React.createElement("text", { dominantBaseline: "hanging", x: 10, y: "10" },
                "margin: ",
                margin,
                "px"),
            React.createElement("rect", __assign({}, borderArea, { style: {
                    fill: 'transparent',
                    stroke: '#000000',
                    strokeWidth: '2',
                } })),
            React.createElement("text", { dominantBaseline: "hanging", x: borderArea.x + 10, y: borderArea.y + 10 },
                "border: ",
                border,
                "px"),
            React.createElement("rect", __assign({}, paddingArea, { style: {
                    fill: 'transparent',
                    stroke: '#000000',
                    strokeWidth: '2',
                } })),
            React.createElement("text", { dominantBaseline: "hanging", x: paddingArea.x + 10, y: paddingArea.y + 10 },
                "padding: ",
                padding,
                "px"),
            React.createElement("rect", __assign({}, contentArea, { style: {
                    fill: 'transparent',
                    stroke: '#000000',
                    strokeWidth: '2',
                } }))),
        React.createElement("div", { ref: elementRef, style: {
                cursor: 'move',
                position: 'absolute',
                width: "".concat(width, "px"),
                height: "".concat(height, "px"),
                border: "".concat(border, "px solid rgba(0, 0, 0, 0)"),
                padding: "".concat(padding, "px"),
                margin: "".concat(margin, "px"),
                boxSizing: 'content-box',
                overflow: 'scroll',
                transform: "translate(".concat(boxElementLocation.x, "px, ").concat(boxElementLocation.y, "px)"),
            }, onMouseDown: handleBoxElementMouseDown, onScroll: handleBoxElementScroll },
            React.createElement("div", { style: { fontSize: '2em', fontWeight: 'bold' } }, box.name),
            React.createElement("div", null,
                "width: ",
                width,
                "px"),
            React.createElement("div", null,
                "height: ",
                height,
                "px"),
            React.createElement("div", { style: {
                    position: 'relative',
                    width: "".concat(width * 4, "px"),
                    height: "".concat(height * 4, "px"),
                } }))));
}
export { BoxElement };
